<template>
  <l-columns>
    <l-columns-column size="7">
      <l-rows>
        <o-form
          :inputs="inputs"
          async
          :title="title"
          :subtitle="subtitles"
          :initial-values="item"
          :submit-text="this.$t('common.save')"
          @submit="handleSubmit"
        />
        <delete-form
          v-if="mode === 'edit'"
          :button-label="deleteButtonLabel"
          :entity-name="item[deleteConfirmationAttribute]"
          :confirmation-needed="deleteConfirmationNeeded"
          @delete="handleDelete"
        />
      </l-rows>
    </l-columns-column>
  </l-columns>
</template>

<script>
  import { OForm, LRows, LColumnsColumn, LColumns } from 'codefabrik-gui-vue'
  import DeleteForm from './DeleteForm'
  import useFormMode from '@/mixins/useFormMode'

  export default {
    name: 'BackOfficeForm',
    components: { OForm, DeleteForm, LRows, LColumnsColumn, LColumns },
    props: {
      item: {
        type: Object,
        default: () => {
          return {}
        }
      },
      modes: {
        type: Object,
        default: () => {
          return {}
        }
      },
      inputs: {
        type: Array,
        default: () => {
          return []
        }
      },
      deleteButtonLabel: {
        type: String,
        default: ''
      },
      deleteConfirmationAttribute: {
        type: String,
        default: ''
      },
      deleteConfirmationNeeded: {
        type: Boolean,
        default: true
      },
    },
    mixins: [
      useFormMode("modes"),
    ],
    methods: {
      handleSubmit (...rest) {
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
  }
</script>

<style scoped>
</style>
